<template>

    <t-page-form-upload
        :type-image="typeImage"
        :command="command"
        :other-entity="otherEntity"
        :path="path" :primaryKeyColumn="primaryKeyColumn" :foreign-key-column="foreignKeyColumn"
        :primary-key="form.occurrenceFileId" :foreign-key="form.checklistItemOccurrenceId"
        :items="items" :user-auth="userAuth" :status="status"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
        :message-not-record="messageNotRecord"
        :only-view="onlyView"
        enable-public
        @onSubmit="onSubmit" @itemDownload="onItemFileDownload" @onItemDelete="onItemDeleteDefault"
        @onUploadComplete="onUploadComplete" @onRequestList="getList">

    </t-page-form-upload>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormUploadMixin from "@/mixins/page/pageFormUploadMixin";
import tPageFormUpload from "@/components/template/page/t-page-form-upload";
import OccurrenceFileType from "@/model/types/modules/checklist/OccurrenceFileType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormUploadMixin],
  components: {tPageFormUpload},
  name: 'ChecklistOccurrenceFile',
  data() {
    return {
      OccurrenceFileType,
      path: "checklist/item/occurrence-file", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "checklistItemOccurrenceFileId",
      foreignKeyColumn: "checklistItemOccurrenceId", //Utilizar quando usar Tabs com outros componentes
      type: "D", //Tipo padrão de modelo de envio de arquivos poderá ser I ou D
      form: {
        checklistItemOccurrenceId: this.foreignKey,
        checklistItemOccurrenceFileId: 0,
        occurrenceFileType: 0,
        orderList: 0,
        type: "",
        subtitle: "",
        fileEntity: {
          nameOriginal: "",
          nameSave: "",
          sizeKb: 0,
          extension: "",
        }
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    otherEntity: Boolean,
    occurrenceFileType: {
      type: Number,
      default: 0,
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      if (this.otherEntity) {
        this.command = 'view'
      }

      this.mountedPrepareFormUploadDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.checklistItemOccurrenceFileId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------

      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
